import { Input } from '@angular/core';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BObjectModel, QResult } from '../../../../models';
import { PipeStageModel } from '../../../../models/formation';
import { CoreService, HttpService } from '../../../../services';
import { ToastService } from '../../../../toast';

@Component({
  selector: 'q-comp-cursus-delete',
  templateUrl: './cursus-delete.component.html',
  styleUrls: ['./cursus-delete.component.css']
})
export class CursusDeleteComponent{


  constructor(
    private modalService: NgbModal,
    private http: HttpService,
    private indParam: CoreService,
    private toast: ToastService,
  ) { }


  public boModel = new BObjectModel();
  @ViewChild('modal') modal: ElementRef;
  @Output() onModalClose = new EventEmitter<boolean>();

  idCursus: string;


  public openModal(idCursus: string) {
    this.idCursus = idCursus;
    this.modalService.open(this.modal, { centered: true, windowClass: 'qmodalover' }).result.then((result) => {
    }, (reason) => {
      this.onModalClose.emit(false);
    });
  }


  public deleteCursus() {
    //TODO changer de model et de service 
    let model = new PipeStageModel();
    model.IdCursus = this.idCursus;
    this.http.postHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/Cursus/DELETE_CURSUS`, model).subscribe((result: QResult<boolean>) => {
      if (result.Value) {
        this.toast.showSuccessToast('Le cursus a bien été supprimé');
        this.onModalClose.emit(true);
      }
    });
  }
}
